import { requests } from '@/libs/axios/axios'
import { OrganizationsEndpoints } from '../organizations-endpoints'
import { EditUserData } from '@/services/users/users.interfaces'

async function editOrganizationUser(body: EditUserData, orgId: number, userId: number) {
  return requests.put(`${OrganizationsEndpoints.ORGANIZATIONS}/${orgId}/users/${userId}`, body)
}

export default editOrganizationUser
